import { useMutation } from "react-query";
import { customApi } from "../../../../../CustomHoock/CustomApi";

export const useGetOrderTypeRatio = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderTypeRatio",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetOrderStatusRatio = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderStatusRatio",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
